export default __webpack_public_path__ + "static/media/lineItemsTable.703d9ce6.svg";